import { CacheService } from './cache-service';
import { LRUCacheService } from './lru-cache';

export const cacheService = new CacheService(new LRUCacheService());
export * from './sentry-session-cache';
export * from './sessionCacheKeys';
export * from './user-context-cache';
